import React, { useMemo, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import {
    CODE_SAMPLE_HINTS,
    CODE_SAMPLE_LANGS,
    buildApiCodeSamples,
} from "../../utils/apiCodeSamples";
import "./CodeSamplesPanel.css";

const CodeSamplesPanel = ({ kind = "text", params = {}, hint }) => {
    const [lang, setLang] = useState("curl");
    const [copied, setCopied] = useState(false);

    const samples = useMemo(() => buildApiCodeSamples(kind, params), [kind, params]);
    const hintText = hint || CODE_SAMPLE_HINTS[kind] || CODE_SAMPLE_HINTS.text;

    const handleCopy = async () => {
        try {
            await navigator.clipboard.writeText(samples[lang] || "");
            setCopied(true);
            setTimeout(() => setCopied(false), 1600);
        } catch (err) {
            console.error("Copy failed", err);
        }
    };

    return (
        <div className="code-samples-panel">
            <div className="code-samples-header">
                <span className="d-inline-flex align-items-center gap-2">
                    <Icon icon="mdi:code-tags" width={18} />
                    Code samples
                </span>
                <button type="button" className="btn btn-sm btn-light" onClick={handleCopy}>
                    <Icon icon={copied ? "mdi:check" : "mdi:content-copy"} width={14} className="me-1" />
                    {copied ? "Copied" : "Copy"}
                </button>
            </div>

            <div className="p-3">
                <p className="code-samples-hint mb-3">{hintText}</p>

                <div className="code-lang-tabs mb-3">
                    {CODE_SAMPLE_LANGS.map((item) => (
                        <button
                            key={item.id}
                            type="button"
                            className={`code-lang-tab ${lang === item.id ? "active" : ""}`}
                            onClick={() => setLang(item.id)}
                        >
                            {item.label}
                        </button>
                    ))}
                </div>

                <pre className="code-samples-block">
                    <code>{samples[lang]}</code>
                </pre>
            </div>
        </div>
    );
};

export default CodeSamplesPanel;
